import React, { useEffect, useState } from "react";
import { Label } from "reactstrap";
import DatePicker from "react-datepicker";
import { CalenderIcon } from "../Icon";
import DownloadTimeSheetReport from "./DownloadTimeSheetReport";
import Select from "react-select";
import { RootState } from "../../redux/rootReducers";
import { connect } from "react-redux";
import { getAllFinacUsersAction } from "../../redux/auth";
import { GetAllFinacUserPayloadType } from "../../commonTypes/authTypes";
import useDebounce from "../../customHooks/useDebounce";
import { typeOfTimeSheetReportDropDown } from "../../constant/timeSheetReportDropDown";
import { GetAllMasterDataActivityCodePayloadType } from "../../commonTypes/masterDataTypes";
import { getAllMasterDataActivityCodeAction } from "../../redux/masterData";
import { CircularAvatar } from "../commons";
import { components } from "react-select";
import moment from "moment";
import { formatDate, handleDate } from "../../utils/commonFunctions";
import EmailAllUserReportPopup from "./EmailAllUserReportPopup";

type AppProps = {
  finacUser?: any;
  token: string | null;
  userFetching: boolean;
  activivtyCodeList?: any;
  isViewUserDropDown?: boolean;
  startDate?: string;
  endDate?: string;
  setType?: (data: string) => void;
  setUserId?: (data: string) => void;
  setActivityCode?: (data: string) => void;
  handleSubmitData?: (data: any) => void;
  setSelectedUser?: (data: string) => void;
  setStartDate?: (data: string) => void;
  setEndDate?: (data: string) => void;
  setCurrentStartDate?: (data: string) => void;
  setCurrentEndDate?: (data: string) => void;
  masterDataActivityCodeListTotal?: string | number;
  dispatchGetAllFinacUsersAction?: (data: GetAllFinacUserPayloadType) => void;
  dispatchGetAllMasterDataActivityCodeList?: (
    data: GetAllMasterDataActivityCodePayloadType
  ) => void;
  handleEmailReportStartDate?: (date: any) => void;
  handleEmailReportEndDate?: (date: any) => void;
  handleResetEmailEndDate?: () => void;
  emailReportStartDate?: string;
  emailReportEndDate?: string;
  handleEmailAllUserTimesheetReportData?: () => void;
  isTimesheetAdminReport?: boolean;
};
const TimeSheetReportHeader = ({
  finacUser,
  dispatchGetAllFinacUsersAction,
  token,
  setStartDate,
  setEndDate,
  userFetching,
  handleSubmitData,
  isViewUserDropDown,
  startDate,
  endDate,
  setActivityCode,
  setUserId,
  setType,
  isTimesheetAdminReport,
  masterDataActivityCodeListTotal,
  dispatchGetAllMasterDataActivityCodeList,
  activivtyCodeList,
  setSelectedUser,
  setCurrentStartDate,
  setCurrentEndDate,
  handleEmailReportEndDate,
  handleEmailReportStartDate,
  emailReportEndDate,
  emailReportStartDate,
  handleResetEmailEndDate,
  handleEmailAllUserTimesheetReportData,
}: AppProps) => {
  const [userList, setUserList] = useState<any>([]);
  const [finalActivityCodeList, setFinalActivityCodeList] = useState<any>([]);
  const [userText, setUserText] = useState("");
  const [activityCodeText, setActivitycodeText] = useState<string>("");
  const [offset, setOffset] = useState<number>(0);
  const [text, setText] = useState<string>("");
  const [limit, setLimit] = useState<number>(20);
  const [loadCondition, setLoadCondition] = useState(true);
  const [downloadFinalData, setDownloadFinalData] = useState({});
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [userBasicDetails, setUserBasicDetails] = useState<any>({
    user: {
      value: "",
      label: "Select..",
    },
    type: {
      value: "",
      label: "Select..",
    },
    activityCode: {
      value: "",
      label: "Select..",
    },
  });
  const userIsLoading = userFetching && text?.length ? true : false;

  const handleStartDateChange = (date: any) => {
    const value = handleDate(date);
    setStartDate?.(value);
  };
  const handleEndDateChange = (date: any) => {
    const value = handleDate(date);
    setEndDate?.(value);
  };
  const checkBottom = (e: any) => {
    setLoadCondition(false);

    setOffset((prv: any) => prv + limit);
  };
  const dropDownStyle = {
    option: (baseStyles: any, state: any) => ({
      ...baseStyles,
      width: "100%",
    }),

    control: (provided: any, state: any) => ({
      ...provided,
      width: "49%",
    }),
    container: (provided: any) => ({
      ...provided,
      width: "183%",
      // position: "absolute",
    }),
  };

  useEffect(() => {
    const finalUserData = finacUser?.data?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name ? user?.first_name : ""} ${
          user?.last_name ? user?.last_name : ""
        }`,
        image: user?.profile_pic?.file_url,
      };
    });
    if (offset > 0) {
      setUserList([...userList, ...finalUserData]);
    } else {
      setUserList(finalUserData);
    }
  }, [finacUser]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset,
        limit,
        user_type: "stco_users",
        status: 1,
        search_term: text,
      };
      if (offset <= finacUser?.total_count) {
        dispatchGetAllFinacUsersAction?.(finalUserData);
      }
    }
  }, [offset]);

  const fetchNewData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      user_type: "stco_users",
      status: 1,
      search_term: text,
    };
    dispatchGetAllFinacUsersAction?.(finalData);
  };

  useDebounce(
    () => {
      if (text) {
        fetchNewData(text);
      } else {
        const finalData = {
          token,
          offset,
          limit,
          user_type: "stco_users",
          status: 1,
          search_term: text,
        };
        dispatchGetAllFinacUsersAction?.(finalData);
      }
    },
    500,
    [text]
  );

  useEffect(() => {
    var activityCode = activivtyCodeList?.map((data: any) => {
      return {
        value: data?._id,
        label: data?.activity_code,
      };
    });
    if (offset > 0) {
      setFinalActivityCodeList([...finalActivityCodeList, ...activityCode]);
    } else {
      setFinalActivityCodeList(activityCode);
    }
  }, [activivtyCodeList]);

  useEffect(() => {
    if (token && masterDataActivityCodeListTotal) {
      let finalUserData = {
        token,
        offset,
        limit,
        search_term: text,
      };
      if (offset <= +masterDataActivityCodeListTotal) {
        dispatchGetAllMasterDataActivityCodeList?.(finalUserData);
      }
    }
  }, [offset]);

  const fetchNewActivityCodeData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      search_term: activityCodeText,
      // search_term: text,
    };
    dispatchGetAllMasterDataActivityCodeList?.(finalData);
  };

  useDebounce(
    () => {
      if (activityCodeText) {
        fetchNewActivityCodeData(activityCodeText);
      } else {
        const finalData = {
          token,
          offset,
          limit,
          search_term: activityCodeText,
        };
        dispatchGetAllMasterDataActivityCodeList?.(finalData);
      }
    },
    500,
    [activityCodeText]
  );

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };

  const handleUserDropdownChange = (e: any, name: string) => {
    // setSelectedUser?.(e?.label)
    setUserBasicDetails((prev: any) => {
      return {
        ...prev,
        user: {
          value: e.value,
          label: e?.label,
        },
      };
    });
    setUserId?.(e.value);
  };
  const handleActivityCodeDropdownChange = (e: any, code: string) => {
    setUserBasicDetails((prev: any) => {
      return {
        ...prev,
        activityCode: {
          value: e.value,
          label: e?.label,
        },
      };
    });
    setActivityCode?.(e.label);
  };
  const handleTypeChange = (data: any) => {
    setUserBasicDetails((prev: any) => {
      return {
        ...prev,
        type: {
          value: data?.value,
          label: data?.label,
        },
      };
    });
    setType?.(data?.value);
  };

  const handleSubmit = () => {
    const finaldata = {
      startDate: formatDate(startDate ? startDate : ""),
      endDate: formatDate(endDate ? endDate : ""),
      offset,
      limit,
      userBasicDetails,
    };
    setDownloadFinalData(finaldata);
    handleSubmitData?.(finaldata);
  };
  const onMenuClose = () => {
    setLoadCondition(true);
  };
  return (
    <>
      <div
        className="d-flex align-items-start"
        style={{
          justifyContent: !isViewUserDropDown ? "space-between" : "",
          width: "96%",
        }}
      >
        {!isViewUserDropDown && (
          <div className="col-md-2 pl-3 form-group d-flex flex-column p-0">
            <label className="mb-1" htmlFor="User">
              User <span className="color-red">*</span>
            </label>

            <Select
              onMenuClose={onMenuClose}
              components={{ Option }}
              styles={dropDownStyle}
              isSearchable={true}
              options={userList}
              isLoading={userFetching}
              // value={userBasicDetails?.firstName}
              value={userBasicDetails?.user}
              onMenuScrollToBottom={(e: any) => checkBottom(e)}
              onChange={(e) => handleUserDropdownChange(e, "user")}
              onInputChange={(e) => {
                setLoadCondition(false);
                setText(e);
                setOffset(0);
              }}
            />
          </div>
        )}

        <div className="col-md-2 pl-0 pr-0">
          <label className="mb-1" htmlFor="">
            From <span className="color-red">*</span>
          </label>
          <div className="date-picker-wraper mr-0">
            <Label className="m-0 p-0 w-100">
              <DatePicker
                dateFormat="dd-MM-yyyy"
                onChange={(e: any) => {
                  handleStartDateChange?.(moment(e).format("YYYY-MM-DD"));
                }}
                maxDate={
                  endDate
                    ? new Date(
                        moment(`${endDate}T00:00:00`, "YYYY-MM-DD").format(
                          "YYYY-MM-DD[T]HH:mm:ss"
                        )
                      )
                    : null
                }
                selected={
                  startDate
                    ? new Date(
                        moment(`${startDate}T00:00:00`, "YYYY-MM-DD").format(
                          "YYYY-MM-DD[T]HH:mm:ss"
                        )
                      )
                    : null
                }
                fixedHeight
                showMonthDropdown
                showYearDropdown
                name="dateOfInvoice"
                placeholderText="Start Date"
                className="form-control pt-0 pb-0"
              />
              <span
                className="calender-icon"
                style={{ right: "10px", top: "35px", cursor: "pointer" }}
              >
                <CalenderIcon />
              </span>
            </Label>
          </div>
        </div>

        <div className="col-md-2">
          <label className="mb-1" htmlFor="">
            To <span className="color-red">*</span>
          </label>
          <div className="form-group">
            <div className="date-picker-wraper mr-0">
              <Label className="m-0 p-0 w-100 d-flex">
                <DatePicker
                  dateFormat="dd-MM-yyyy"
                  selected={
                    endDate
                      ? new Date(
                          moment(`${endDate}T00:00:00`, "YYYY-MM-DD").format(
                            "YYYY-MM-DD[T]HH:mm:ss"
                          )
                        )
                      : null
                  }
                  onChange={(e: any) => {
                    handleEndDateChange?.(moment(e).format("YYYY-MM-DD"));
                  }}
                  fixedHeight
                  showMonthDropdown
                  showYearDropdown
                  name="dateOfInvoice"
                  placeholderText="End Date"
                  className="form-control pt-0 pb-0"
                  minDate={
                    startDate
                      ? new Date(
                          moment(`${startDate}T00:00:00`, "YYYY-MM-DD").format(
                            "YYYY-MM-DD[T]HH:mm:ss"
                          )
                        )
                      : null
                  }
                />
                <span
                  className="calender-icon"
                  style={{ right: "22px", top: "35px", cursor: "pointer" }}
                >
                  {" "}
                  <CalenderIcon />
                </span>
              </Label>
            </div>
          </div>
        </div>
        {/* </div> */}

        <div className="col-md-2 d-flex flex-column p-0">
          <label className="mb-1" htmlFor="">
            Type
          </label>
          <Select
            options={typeOfTimeSheetReportDropDown}
            value={userBasicDetails?.type}
            onChange={handleTypeChange}
          />
        </div>
        <div className="col-md-2 d-flex flex-column pl-3 pr-0">
          <label className="mb-1" htmlFor="">
            Activity code
          </label>
          <Select
            onMenuClose={() => {
              setOffset(0);
            }}
            isSearchable={true}
            options={
              finalActivityCodeList
                ? [{ value: null, label: "Select.." }, ...finalActivityCodeList]
                : [{ value: null, label: "Select.." }]
            }
            value={userBasicDetails?.activityCode}
            onChange={(e) =>
              handleActivityCodeDropdownChange(e, "activityCode")
            }
            onInputChange={(e) => {
              // setText(e);
              setActivitycodeText(e);
            }}
            onMenuScrollToBottom={(e: any) => checkBottom(e)}
          />
        </div>

        <div className="col-md-1 mt-4">
          <button
            className="btn btn-primary mt-1 pt-2 pb-2"
            onClick={handleSubmit}
            disabled={
              !startDate ||
              !endDate ||
              (!isViewUserDropDown && !userBasicDetails?.user?.value)
            }
          >
            Apply
          </button>
        </div>
        <div
          className={`${
            isViewUserDropDown
              ? "d-flex ml-3 mt-4 pr-2"
              : "d-flex ml-2 mt-4 pr-2"
          }`}
        >
          <DownloadTimeSheetReport
            token={token}
            startDate={startDate}
            downloadFinalData={downloadFinalData}
            endDate={endDate}
            userBasicDetails={userBasicDetails}
            isViewUserDropDown={isViewUserDropDown}
          />
          <div className="mt-1" style={{ marginLeft: "13.2px" }}>
            {isTimesheetAdminReport ? (
              <EmailAllUserReportPopup
                type={"TimeSheetReports"}
                setShowDropdown={setShowDropdown}
                showDropdown={showDropdown}
                header={"Email TimeSheet Report"}
                emailReportStartDate={emailReportStartDate}
                emailReportEndDate={emailReportEndDate}
                handleResetEmailEndDate={handleResetEmailEndDate}
                handleEmailReportStartDate={handleEmailReportStartDate}
                handleEmailReportEndDate={handleEmailReportEndDate}
                handleEmailAllUserTimesheetReportData={
                  handleEmailAllUserTimesheetReportData
                }
              />
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  finacUser: state.auth.finacUsersList,
  activivtyCodeList: state.masterData.masterDataActivivtyCodeListing,
  masterDataActivityCodeListTotal:
    state.masterData.masterDataActivityCodeListTotal,
  userFetching: state.auth.fetching,
});

const dispatchStateToProps = (dispatch: any) => ({
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchGetAllMasterDataActivityCodeList: (
    data: GetAllMasterDataActivityCodePayloadType
  ) => dispatch(getAllMasterDataActivityCodeAction(data)),
});

export default connect(
  mapStateToProps,
  dispatchStateToProps
)(TimeSheetReportHeader);
